<template>
  <component :is="tag" v-if="firstTopic.title || firstTopic.name" class="fields field-topic" :style="{'color': color}">
    <term-link
      v-gtm-tracker="!isEmpty(gtmType) ? assignIn({}, gtmType, {el: get(firstTopic, 'relative_url', false)}) : {}"
      :tid="firstTopic.tid"
      :title="firstTopic.title || firstTopic.name"
      :url="firstTopic.relative_url"
      :type="firstTopic.type"
    >{{ truncate(firstTopic.title || firstTopic.name, {length: truncateLength > 0 ? this.truncateLength : 999, separator: /,? +/,}) }}</term-link>
  </component>
</template>
<script>
import head from 'lodash/head'
import isArray from 'lodash/isArray'
import truncate from 'lodash/truncate'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import assignIn from 'lodash/assignIn'

export default {
  name: 'field-topic',
  props: {
    color: {
      type: String,
      default: '',
    },
    topics: [Array, Object],
    tag: {
      type: String,
      default: 'div',
    },
    truncateLength: {
      type: [Number, String],
      default: 999,
    },
    gtmType: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    firstTopic() {
      let topic = {}
      if (isArray(this.topics)) {
        topic = head(this.topics)
      }
      return topic
    },
  },
  data() {
    return {}
  },
  methods: {
    truncate,
    isEmpty,
    get,
    assignIn,
  },
}
</script>



// WEBPACK FOOTER //
// components/node/fields/Topic.vue